import { Component, OnInit, Inject } from '@angular/core';
import { _ } from '@icc/shared/helpers';
import { PageComponent, ICC_PAGE_DATA, SharedFacade, ModalService } from '@icc/configurator/shared';
import { iccListItem, iccListTab } from '@icc/configurator/ui';
import { IccFilling } from '@icc/window-door/types';
import { ModelInfoComponent } from '../model-info/model-info.component';

@Component({
    selector: 'icc-model-list-page',
    templateUrl: './model-list-page.component.html',
    styleUrls: ['./model-list-page.component.scss'],
    standalone: false
})
export class ModelListPageComponent extends PageComponent implements OnInit{
    public title = _('DOOR|Model');
    models = this.data.fillings.map<iccListItem>(model => ({
        id: model.id,
        fullId: model.id,
        title: model.name,
        imageUrl: '/files/filling/' + (this.data.fillingsViewSide === 'inner' && model.image_in ? model.image_in : model.image),
        tabs: [model.fillings_category_id],
        showInfo: true
    }));
    modelCategories = this.data.fillingsCategories.map<iccListTab>(group => ({
        id: Number(group.id),
        name: group.name,
    }));
    currentModelGroup = null;
    selectedFilling = this.data.selectedFilling && parseInt(this.data.selectedFilling.id);

    constructor(
        private sharedFacade: SharedFacade,
        private modalService: ModalService,
        @Inject(ICC_PAGE_DATA) private data: {
            fillings: IccFilling[],
            fillingsCategories: any[],
            selectedFilling: IccFilling,
            fillingsViewSide?: 'inner' | 'outer',
            predefinedFillingLayouts?: any[]
        }
    ) {
        super();
    }

    ngOnInit() {
    }

    /**
     * Wybieranie modelu
     * @param  {Object} model Model
     */
    selectModel(modelItem: iccListItem) {
        const filling = this.data.fillings.find(m => String(m.id) === String(modelItem.fullId));
        if (filling) {
            this.sharedFacade.closePage({
                filling
            });
        }
    }

    showInfo(item: iccListItem) {
        const filling = this.data.fillings.find(m => String(m.id) === String(item.fullId));
        const modalService = this.modalService
            .open({
                pageComponent: ModelInfoComponent,
                resolve: {
                    filling: () => filling,
                    button: () => true,
                    fillingViewSide: () => this.data.fillingsViewSide,
                    imageUrl: () => item.imageUrl
                },
            })
            .result.then((result: boolean) => {
                if (result) {
                    this.selectModel(item);
                }
            });
    }

}
